var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classMenu"},[_c('van-tabs',{ref:"classMenu",attrs:{"active":_vm.active,"swipe-threshold":"3"},on:{"click":_vm.tabChange}},_vm._l((_vm.menuList),function(item){return _c('van-tab',{attrs:{"title":item.title,"name":item.name}},[_c('router-view')],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }